/**
 * Display sizes for images placed inside article bodies.
 *
 * Deliberately free of Payload imports: the Payload collection config (server)
 * and BlogRichTextReader (client) both depend on these values, and pulling
 * `@payloadcms/richtext-lexical` into the client bundle would drag the whole
 * server `payload` package along with it.
 */
export const BLOG_IMAGE_SIZES = ["small", "medium", "large"] as const;

export type BlogImageSize = (typeof BLOG_IMAGE_SIZES)[number];

/** Applied to uploads saved before the size field existed, which have `fields: null`. */
export const DEFAULT_BLOG_IMAGE_SIZE: BlogImageSize = "large";
